import React from "react";
import "./Skills.scss";

export default function LineProgressBar(props) {
    return(
        <React.Fragment>
            <div className="bg-white w-100 p-0 m-0" id="block2"><hr className="skill p-0 m-0" width={`${props.value}`}/></div>
        </React.Fragment>
    );

}